// extracted by mini-css-extract-plugin
module.exports = {"Container":"Profile_Container__3s49E","Uppercase":"Profile_Uppercase__ixAH1"};